/* eslint-disable */
export default {
  createCallLog: '建立通話記錄',
  viewInSalesforce: '在 Salesforce 中檢視',
  createLog: '建立記錄',
} as const;

// @key: @#@"createCallLog"@#@ @source: @#@"Create call log"@#@
// @key: @#@"viewInSalesforce"@#@ @source: @#@"View in Salesforce"@#@
// @key: @#@"createLog"@#@ @source: @#@"Create log"@#@
